import { itemFormsApi } from "@/api/endpoints";
import { ReferenceNameMasterPage } from "./ReferenceNameMasterPage";

export function ItemFormsPage() {
  return (
    <ReferenceNameMasterPage
      title="Item Forms"
      noun="Form"
      api={itemFormsApi}
      queryKey="item-forms"
      permPrefix="catalog.form"
    />
  );
}
